import { Storage } from './storage';
import { LocalStorage } from './localStorage';
import { CookieStorage } from './cookieStorage';

// gathered ideas from https://github.com/samyk/evercookie/blob/master/js/evercookie.js

export type CartItemTypes = 'blaze' | 'luminex' | 'no-steno';

export interface CartState {
    cartItems: CartItem[];
}

export interface CartItem {
    item: CartItemTypes;
    amount: number;
}

export class CartStore { 
    private stores: Storage[] = [];

    constructor() {
        this.stores.push(new LocalStorage());
        this.stores.push(new CookieStorage());
    }

    set = async (cart: CartState) => {
        for (let store of this.stores) {
            store.set(cart);
        }
    }

    get = async (): Promise<CartState> => {
        let value;
        for (let store of this.stores) {
            value = await store.get()
            if (value) {
                break;
            }
        }
        if (!value) {
            return { cartItems: [] };
        }
        return value;
    }
}